
export default () => {
  const { confGlobal } = useConfig()

  return {
    root: {
      class: [
        // Misc
        'overflow-x-auto',
        'overflow-y-hidden',

        'text-[14px]',

        // Colors
        (() => { 
          if (confGlobal.site === 'customusb') {
            return 'text-second-400 dark:text-white/90'
          } else {
            return 'text-surface-600 dark:text-white/70'
          }
        })
      ]
    },
    list: ({ props }) => ({
      class: [
      // Flex & Alignment
        'flex items-center flex-nowrap',
        { 'justify-center': props.ptOptions?.isCenter === true },

        // Spacing
        'm-0 p-0 py-1 list-none leading-none'
      ]
    }),
    itemLink: {
      class: [
      // Flex & Alignment
        'flex items-center gap-2',

        // Shape
        'rounded-md',

        // States
        'focus-visible:outline-none focus-visible:outline-offset-0',
        'focus-visible:ring-1 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400',

        // Transitions
        'transition-shadow duration-200',

        // Misc
        'text-decoration-none'
      ]
    },
    itemIcon: {
      class: ''
    },
    separator: {
      class: [
      // Flex & Alignment
        'flex items-center',

        // Spacing
        'mx-2'
      ]
    },
    separatoricon: {
      width: '10',
      heigth: '10'
    }
  }
}